var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1259_26751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5865 36.5491C59.9092 34.4772 64.1824 31.7461 64.1824 31.7461L64.3283 31.6204L64.1824 31.4954C64.1824 31.4954 59.9808 28.8465 58.7182 26.805C58.2365 26.0262 58.0066 25.0555 58.0484 24.1407C58.1608 21.6854 60.4916 17.1837 60.4916 17.1837L60.556 17.0015L60.367 16.9663C60.367 16.9663 55.3927 16.7722 53.2734 15.6332C52.4754 15.2044 51.7977 14.4871 51.381 13.6827C50.2473 11.4948 50.0149 6.41736 50.0149 6.41736L49.9801 6.22804L49.7994 6.29127C49.7994 6.29127 45.3968 8.60418 42.9936 8.68208C42.0402 8.713 41.0424 8.42308 40.2379 7.91057C38.1022 6.54997 35.2897 2.14592 35.2897 2.14592L35.164 2L35.039 2.14592C35.039 2.14592 32.2343 6.56319 30.0901 7.91096C29.4316 8.32482 28.6129 8.54254 27.8357 8.51259C25.3062 8.41515 20.6707 5.99567 20.6707 5.99567L20.4896 5.93206L20.4541 6.12101C20.4541 6.12101 20.2351 11.3476 19.0509 13.5855C18.7091 14.2315 18.1439 14.7922 17.4971 15.1326C15.3164 16.2804 10.2313 16.4982 10.2313 16.4982L10.042 16.5338L10.1064 16.7149C10.1064 16.7149 12.4186 21.1104 12.4931 23.5099C12.5215 24.4225 12.2391 25.3764 11.7475 26.1458C10.4225 28.2194 6.14561 30.9541 6.14561 30.9541L6.00006 31.0794L6.14561 31.2044C6.14561 31.2044 10.3452 33.8514 11.606 35.8922C12.0895 36.6748 12.319 37.6503 12.2765 38.5693C12.1631 41.0213 9.83556 45.517 9.83556 45.517L9.77195 45.6981L9.96052 45.7336C9.96052 45.7336 14.9213 45.9269 17.0343 47.0634C17.8431 47.4984 18.5293 48.2264 18.9515 49.0419C20.0806 51.223 20.3124 56.2833 20.3124 56.2833L20.3483 56.4726L20.5297 56.4079C20.5297 56.4079 24.9124 54.1027 27.3049 54.0282C28.2287 53.9994 29.1941 54.2849 29.973 54.7825C32.0409 56.1036 34.7682 60.3683 34.7682 60.3683L34.8939 60.5146L35.0192 60.3683C35.0192 60.3683 37.6611 56.1778 39.6973 54.9187C40.4853 54.4314 41.4675 54.1987 42.3931 54.2411C44.8415 54.3534 49.3299 56.6787 49.3299 56.6787L49.5128 56.7423L49.5469 56.553C49.5469 56.553 49.7411 51.5955 50.8763 49.4834C51.3115 48.6736 52.0393 47.9858 52.8555 47.5628C55.0362 46.433 60.0969 46.2024 60.0969 46.2024L60.2859 46.1657L60.2226 45.9846C60.2226 45.9846 57.9144 41.5961 57.8389 39.2004C57.81 38.2826 58.0924 37.3231 58.5865 36.5491Z",
    fill: "#FFA900",
    stroke: "#FFA900",
    strokeWidth: 2.07202
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7833 13.7635C28.1416 12.2446 19.0948 18.9144 17.6414 28.6222C16.1225 38.2639 22.7924 47.3108 32.5002 48.7641C42.208 50.217 51.1887 43.6131 52.7073 33.9053C54.1601 24.2637 47.4902 15.2168 37.7824 13.7635H37.7833Z",
    fill: "#FF9D00",
    stroke: "#FF9B00",
    strokeWidth: 2.07202
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5329 14.2197C29.2935 12.7615 20.624 19.1646 19.2313 28.4842C17.7758 37.7402 24.1674 46.4252 33.4702 47.8204C42.773 49.2152 51.3791 42.8755 52.8343 33.5559C54.2266 24.2999 47.8348 15.6149 38.532 14.2197H38.5329Z",
    fill: "#FFB800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1259_26751",
    x: 0.411072,
    y: 0.410156,
    width: 69.5072,
    height: 69.6953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1259_26751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1259_26751",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.c4997d7bc47967113ef44782805cc268.svg";
export { ForwardRef as ReactComponent };